<template>
  <section class="container insiders-guide" aria-label="Insider's Guide">
    <div class="row flex-row">
      <div class="px-0 px-lg-3 col-12 col-lg-4">
        <img
          :src="`${background}uploads/city/${cityId}/${image}`"
          class="img-fluid"
          aria-hidden="true"
          :alt="imageDescription"
        />
      </div>
      <div class="col-12 col-lg-8 text-left center-col px-5">
        <h2>{{ headline }}</h2>
        <p>{{ description }}</p>
        <router-link
          v-if="link.startsWith('https://alabama.travel')"
          :to="link.replace('https://alabama.travel', '')"
          class="blue-button"
        >
          {{ linkText }}
        </router-link>
        <a v-else class="blue-button" :href="link" target="__blank">
          {{ linkText }}
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  computed: {
    background() {
      return process.env.VUE_APP_S3_BUCKET;
    },
  },
})
class InsidersGuide extends Vue {
  @Prop({
    type: String,
    required: true,
  })
  description;

  @Prop({
    type: String,
    required: true,
  })
  image;

  @Prop({
    type: String,
  })
  cityname;

  @Prop({
    type: String,
  })
  cityId;

  @Prop({
    type: String,
  })
  linkText;

  @Prop({
    type: String,
  })
  link;

  @Prop({
    type: String,
  })
  headline;

  @Prop({
    type: String,
  })
  imageDescription;
}

export default InsidersGuide;
</script>

<style scoped>
.insiders-guide {
  max-width: 1450px;
  margin-top: 4em;
  min-height: 24em;
}

.flex-row {
  align-content: stretch;
  min-height: 24em;
}

.center-col {
  display: flex;
  flex-direction: column;
  place-content: center;
  @media only screen and (max-width: 1200px) {
    margin-top: 3em;
  }
}

.img-fluid {
  max-height: 30rem;
  height: 100%;
  object-fit: cover;
  padding: 0;
  @media only screen and (min-width: 998px) {
    border-radius: var(--spacing-xs);
  }
}
.blue-button {
  background-color: #173945;
  border-radius: 8px;
  border: solid 1px #4e97b2;
  color: #fff;
  font-size: 19px;
  min-height: 40px;
  padding: 14px;
  text-decoration: none;
  margin-bottom: 20px;
  max-width: min-content;
  text-align: center;
  white-space: nowrap;
}
.blue-button:hover,
.blue-button:focus,
.blue-button:focus-visible {
  border: solid 1px #4e97b2;
  background-color: #316273;
}

.region-color h2 {
  color: #d86f48;
}
</style>
